// removed by extract-text-webpack-plugin
module.exports = {"card-date":"card-date___3dU5s","countdown":"countdown___1-YQq","clock":"clock___33YPc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogDate/CatalogDate.scss
// module id = AN9j
// module chunks = 46